"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var material_1 = require("@mui/material");
var useIsSmallScreen_1 = __importDefault(require("@/frontend/react/hooks/useIsSmallScreen"));
var trans_1 = __importDefault(require("@/plugins/trans"));
var VacancySearchResults_1 = __importDefault(require("./VacancySearchResults"));
var VacancyAlert_1 = __importDefault(require("./VacancyAlert"));
var useShowVacancy_1 = __importDefault(require("./useShowVacancy"));
var ApplyShare_1 = require("./components/ApplyShare");
var Pagination_1 = __importDefault(require("../components/Pagination"));
var AppLayout_1 = require("../AppLayout");
var classes = {
    container: {
        mt: { xs: 0, md: -5 },
    },
};
var VacanciesPage = function (_a) {
    var _b;
    var vacancies = _a.vacancies, onPageChange = _a.onPageChange;
    var isSmallScreen = (0, useIsSmallScreen_1.default)();
    var vacancyParam = (0, react_router_dom_1.useParams)().vacancyId;
    var isBookmarkedPage = !!(0, react_router_dom_1.useMatch)('saved-vacancies/*');
    var navigate = (0, react_router_dom_1.useNavigate)();
    var showVacancy = (0, useShowVacancy_1.default)();
    (0, react_1.useEffect)(function () {
        var _a, _b;
        if (isSmallScreen) {
            return;
        }
        if (!vacancyParam && ((_a = vacancies === null || vacancies === void 0 ? void 0 : vacancies.data) === null || _a === void 0 ? void 0 : _a.length)) {
            showVacancy(vacancies.data[0].id, vacancies.data[0].slug);
        }
        if (vacancyParam && ((_b = vacancies === null || vacancies === void 0 ? void 0 : vacancies.data) === null || _b === void 0 ? void 0 : _b.length) === 0) {
            navigate(isBookmarkedPage ? '/saved-vacancies' : '/vacancies');
        }
    }, [vacancies]);
    // componentDidUpdate() {
    //   const token = new URLSearchParams(document.location.search).get('token');
    //   if (token) {
    //     this.setState({ ready: false });
    //     authorizeUserLight(token).then(() => this.setState({ ready: true }));
    //   }
    // }
    return ((0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ container: true, spacing: isSmallScreen ? 0 : 5, sx: __assign({}, AppLayout_1.appLayoutClasses.container) }, { children: [(0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 12, md: 10, sx: { display: isSmallScreen && vacancyParam ? 'none' : 'block' } }, { children: (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ mt: 4, mb: 4, mr: 1, ml: 4 }, { children: (0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ variant: "h3", color: "primary.dark", sx: { fontWeight: 'bold' } }, { children: trans_1.default.get('labels.frontend.vacancy.found_amount', { amount: "".concat((_b = vacancies === null || vacancies === void 0 ? void 0 : vacancies.total) !== null && _b !== void 0 ? _b : 0) }) })) })) })), (0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ item: true, xs: 12, md: 3, sx: { display: isSmallScreen && vacancyParam ? 'none' : 'block', margin: { xs: 3, md: 0 } } }, { children: [(0, jsx_runtime_1.jsx)(VacancySearchResults_1.default, { ready: true, vacancies: (vacancies === null || vacancies === void 0 ? void 0 : vacancies.data) || [] }), (0, jsx_runtime_1.jsx)(VacancyAlert_1.default, {}), (0, jsx_runtime_1.jsx)(Pagination_1.default, { entity: vacancies, onPageChange: function (newPage) {
                            if (onPageChange) {
                                onPageChange(newPage);
                            }
                        } })] })), (0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ item: true, xs: 12, md: 7 }, { children: [(0, jsx_runtime_1.jsx)(material_1.Stack, __assign({ spacing: 8 }, { children: (0, jsx_runtime_1.jsx)(react_router_dom_1.Outlet, {}) })), (0, jsx_runtime_1.jsx)(ApplyShare_1.StickyApplyShare, {})] }))] })));
};
exports.default = VacanciesPage;
